exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#StdAttribute[data-v-a3c3db1e] .el-input-number.is-without-controls .el-input__inner{text-align:left}[data-v-a3c3db1e] .el-dialog__header{height:auto!important;padding:4px 10px 2px 10px!important}[data-v-a3c3db1e] .el-dialog__headerbtn{top:2px!important;right:5px!important}[data-v-a3c3db1e] .el-dialog__footer{height:auto!important;padding:10px 0 10px 0!important}[data-v-a3c3db1e] .el-dialog__body{padding:20px 10px!important;overflow:hidden!important}[data-v-a3c3db1e] .el-dialog{height:auto!important}[data-v-a3c3db1e] .el-form-item__label{padding:0!important}", ""]);

// exports
